import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Rating from "./Rating";
import Price from "./Price";

const Book = ({ book }) => {
  const [img, setImg] = useState();

  useEffect(() => {
    const image = new Image();
    image.src = book.url;
    image.onload = () => {
      setTimeout(() => {
        setImg(image);
      }, 300);
    };
  });

  return (
    <div>
      <div className="book">
        {img ? (
          <>
            <Link to={`/react-online-library/books/${book.id}`}>
              <figure className="book__img--wrapper">
                <img src={img.src} alt="" className="book__img" />
              </figure>
            </Link>
            <div className="book__details">
              <div className="book__title">
                <Link to={`/react-online-library/books/${book.id}`} className="book__title--link">
                  {book.title}
                </Link>
              </div>
              <Rating rating={book.rating} />
              <Price
                salePrice={book.salePrice}
                originalPrice={book.originalPrice}
              />
            </div>
          </>
        ) : (
          <>
            <div className="book__img--skeleton"></div>
            <div className="skeleton book__title--skeleton"></div>
            <div className="skeleton book__rating--skeleton"></div>
            <div className="skeleton book__price--skeleton"></div>
          </>
        )}
      </div>
    </div>
  );
};

export default Book;
